import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { AppProvider } from "./context/AppContext";

import Navbar from "./components/Navbar";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Calendar from "./pages/Calendar";
import TeamDetail from "./pages/TeamDetail";
import Gallery from "./pages/Gallery";
import LiveMatchPage from "./pages/LiveMatchPage";
import Rules from "./pages/Rules";

import Login from "./pages/Admin/Login";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import ProtectedRoute from "./components/Admin/ProtectedRoute";

import theme from "./Theme";

function Layout() {
  const location = useLocation();

  const isAdminRoute = location.pathname.startsWith("/admin");

  const lastScroll = useRef(0);
  const [showNavbar, setShowNavbar] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    if (isAdminRoute) return;

    const handleScroll = () => {
      const current = window.scrollY;

      if (current < 80) {
        setShowNavbar(true);
      } else if (current > lastScroll.current) {
        setShowNavbar(false);
      } else {
        setShowNavbar(true);
      }

      lastScroll.current = current;
    };

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isAdminRoute]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      {!isAdminRoute && (
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 1200,
            transition: "transform .28s ease, opacity .28s ease",
            transform: showNavbar ? "translateY(0)" : "translateY(-110%)",
            opacity: showNavbar ? 1 : 0,
          }}
        >
          <Navbar />
        </Box>
      )}

      {!isAdminRoute && <Scroll />}

      <Box sx={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/calendario-de-partidos" element={<Calendar />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/equipos/:team_id" element={<TeamDetail />} />
          <Route path="/partido/:match_id" element={<LiveMatchPage />} />
          <Route path="/basketball-rules" element={<Rules />} />
          <Route path="/admin-login" element={<Login />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>

      {!isAdminRoute && <Footer />}
    </Box>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AppProvider>
        <BrowserRouter>
          <Layout />
        </BrowserRouter>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;